import { string } from '@amcharts/amcharts4/core';
import { PurchaseReportFillterModel } from './../models/fillterModels/purchaseReportFillterModel';

import { ChangePasswordModel } from './../models/profile/changePasswordModel';
import { DeviceLocationModel } from './../models/theft/deviceLocationModel';
import { TheftDetailModel } from './../models/theft/theftDetailModel';

import { NewTicketModel } from './../models/newTicketModel';
import { TicketMessageModel } from './../models/ticketMessageModel';

import { MyDeviceModel } from '../models/myDeviceModel';
import { PurchaseReportModel } from './../models/purchaseReportModel';
import { DeviceModel } from './../models/deviceModel';

import { Injectable, Inject } from '@angular/core';
import { Observable, observable } from 'rxjs';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { BaseService } from '../../shared/baseService';
import { map, tap } from 'rxjs/operators';
import { TicketModel } from '../models/ticketModel';
import { UserProfileModel } from '../models/userProfileModel';
import { ProductModel } from '../models/productModel';
import { UserInfoModel } from '../models/userInfoModel';
import { ReportTheftDeviceModel } from '../models/theft/reportTheftDeviceModel';
import { ConfirmTheftDeviceModel } from '../models/theft/confirmTheftDeviceModel';
import { ResellerInfoModel } from '../models/profile/reellerInfoModel';
import { DeviceIpFillterModel } from '../models/fillterModels/deviceIpFillterModel';
import { ResellerUpdateModel } from '../models/profile/resellerUpdateModel';
import { SerialFillterModel } from '../models/fillterModels/serialFillterModel';
import { SerialInfoModel } from '../models/serialInfoModel';

import { ResellerMembersProductReturnModel } from '../models/profile/resellerMembersProductReturnModel';
import { ResellerMembersSerialNumberSearchModel } from '../models/profile/resellerMembersSerialNumberSearchModel';
import { DeviceGetLastLocationModel } from '../models/theft/deviceGetLastLocationModel';
import { DownloadSerialModel } from '../models/downloadSerialModel';
import { DeviceFillterModel } from '../models/fillterModels/deviceFillterModel';

import { BankAccountInfo } from '../models/AffiliateModels/bankAccountInfo';
import { SheedProductModel } from '../models/sheedProductModel';
import { CommonService } from '../../shared/services/common.service';
import { EnumTableModel } from '../../admin/models/enumTableModel';
import { UserOfferWebModel } from '../models/offers/userOfferWebModel';
import { WebPanelNotificationReturnModel } from '../models/webPanelNotifications/webPanelNotificationReturnModel';
import { ApiResponseModel } from '../../admin/models/apiResponseModel';
import { SetPasswordModel } from '../models/profile/setPasswordModel';
import { RegisterUserModel } from '../../../../core/auth/_models/registerUserModel';
import { ResellerUserModel } from '../models/ResellerUserModel';
import { ResellerUserFillterModel } from '../models/fillterModels/resellerUserFillterModel';
// ---------------------------------- URL -----------------------------------------
const DEVICE_LIST_URL = 'Auth/Devices/GetUserDeviceDetail';
const ADD_RESELLER_USER = 'Auth/accounts/RegisterNewUserByReseller';

const GET_WEB_PANEL_NOTIFICATIONS = 'Auth/Web/Notification/user';
const GET_USER_TICKETS = 'Auth/tickets/getLastUserTickets?count=1000';
const GET_DEVICE = 'Auth/Devices/GetUserDeviceHardwareInfo';
const DEVICE_HARDWARE_LIST_URL = 'Auth/Devices/GetUserDevicesWithHardwareInfo';
const GET_TICKET_MESSAGE = 'Auth/tickets/getuserticketMessages';
const GET_INVITE_URL = 'Auth/Orders/GenerateInvitationLinkForUser';
const GET_TICKET = 'auth/tickets/getuserticket'
const PURCHASE_REPORT = 'Auth/Orders/PurchasesReport';
const GET_USER_PROFILE = 'Auth/Profile/Web/getUserProfile';
const GET_EDUCATION_LEVELS = 'Auth/Profile/GetEducationLevels';
const GET_USAGE_FIELDS = 'Auth/Profile/GetUsageFields';
const UPDATE_USER_PROFILE = 'auth/Profile/updateprofile';
const SEND_INVITE_LINK = 'Auth/Orders/SendInviteLink?emailAddresses=';
const SEND_INVITE_LINK_SMS = 'Auth/Orders/SendInviteLinkBySms?phoneNumber=';
const ADD_NEW_TICKET = 'auth/tickets/addticket';
const UPLOAD_TICKET_FILE = 'auth/tickets/uploadTicketFile';
const ADD_TICKET_MESSAGE = 'auth/tickets/addticketmessage';
const TICKET_CLOSE = 'auth/tickets/closeTicket?ticketId=';
const REQUEST_SERIAL_EMAIL = 'Auth/Orders/RequestSerialEmail?orderId=';
const DOWNLAOD_SERIAL = 'Auth/Orders/DownloadSerials?orderId=';
const GET_DEVICE_PRODUCTS = 'Auth/Devices/Web/GetProductsByDeviceId';
const GET_USER_INFO = 'Auth/accounts/GetUserInfo';
const REPORT_THEFT_DEVICE = 'Auth/Devices/ReportTheftDevice';
const CONFIRM_THEFT_DEVICE = 'Auth/Devices/confirmtheftdevice';
const REPORT_UN_THEFT_DEVICE = 'Auth/Devices/ReportUnTheftDevice';
const GET_ALL_LAST_IPS = 'Auth/Devices/Web/GetLastIPs';
const GET_DEVICE_LOCATIONS = 'Auth/Devices/GetDeviceLocations';
const GET_LAST_LOCATION = 'Auth/Devices/GetLastLocation';
const CHANGE_PASSWORD = 'Auth/accounts/changePassword';
const SET_PASSWORD = 'Auth/accounts/setPassword';
const GET_RESELLER_PROFILE = 'Auth/Profile/web/GetResellerProfile';
const GET_USER_DETAIL = 'Auth/accounts/getUserDetails';
const UPDATE_RESELLER_INFO = 'Auth/Profile/UpdateResellerInfo';
const GET_RESELLER_SERIAL_PACKAGES = 'auth/Reseller/GetResellerPackageSerialNumbers';
const SAVE_RESELLER_DOCUMENT = 'auth/Reseller/SaveResellerDocuments';
const GET_RESELLER_USERS = 'Auth/Reseller/GetUsersByReseller';
const REQUEST_RESELLER = 'Auth/Reseller/RequestReseller';
const RESEND_CONFIRM_EMAIL = 'Auth/accounts/ResendConfirmationEmail?email=';
const CONFIRM_EMAIL = 'Auth/accounts/ConfirmEmail';
const ISVALID_EMAIL = 'Auth/accounts/IsValidEmail?email=';
const GET_RESELLER_MEMBERS_SERIAL_NUMBER = 'Auth/Packages/GetResellerMembersSerialNumber';
const CREATE_OPTIONAL_DISCOUNT = 'Auth/Orders/CreateOptionalDiscount?code=';

const GET_USER_BANK_ACCOUNT_INFO = 'Auth/accounts/GetUserBankAccountInfo';
const UPDATE_USER_BANK_ACCOUNT_INFO = 'Auth/accounts/UpdateUserBankAccountInfo';
const GET_ALL_PRODUCTS = 'Auth/Products/web/getallproducts';
const GET_OFFER = 'Auth/Offer/User/web/last';
const REGISTER_USER = 'Auth/accounts/Register';
// ---------------------------------- URL -----------------------------------------
@Injectable()
export class AccountService extends BaseService {
  apiEndpoint: string;
  constructor(private http: HttpClient,
    private commonService: CommonService
  ) {
    super();

  }

  ngOnInit() {
  }
  getAllDevices() {
    return this.http.get<MyDeviceModel[]>(
      `${this.commonService.getApiEndpoint()}/${DEVICE_LIST_URL}`
    ).pipe(map(res => res['result'] as MyDeviceModel[]));
  }

  getResellerUsers(fillter:ResellerUserFillterModel){

    let params = new HttpParams();

    if (fillter != null) {
      if (fillter.filter != null)
        params = params.append('filter', fillter.filter.toString());

      if (fillter.start != null)
        params = params.append('start',fillter.start.toString());

      if (fillter.length != null)
        params = params.append('length', fillter.length.toString());

    }

    return this.http.get<ResellerUserModel[]>(
      `${this.commonService.getApiEndpoint()}/${GET_RESELLER_USERS}`, { params: params }
    );
  }

  getAllWebPanelNotifications() {
    return this.http.get<ApiResponseModel<WebPanelNotificationReturnModel[]>>(
      `${this.commonService.getApiEndpoint()}/${GET_WEB_PANEL_NOTIFICATIONS}`
    ).pipe(map(res => res['result'] as ApiResponseModel<WebPanelNotificationReturnModel[]>));
  }

  markNotificationAsViewed(id: number) {
    return this.http.put<ApiResponseModel<boolean>>(
      `${this.commonService.getApiEndpoint()}/${GET_WEB_PANEL_NOTIFICATIONS}/${id}/view`, id
    ).pipe(map(res => res['result'] as ApiResponseModel<boolean>));
  }


  getUserTickets() {
    return this.http.get<TicketModel[]>(
      `${this.commonService.getApiEndpoint()}/${GET_USER_TICKETS}`
    ).pipe(map(res => res['result'] as TicketModel[]));
  }
  getUserDevicesWithHardwareInfo(userName: string = null, fillter: DeviceFillterModel = null): Observable<DeviceModel[]> {


    let params = new HttpParams();

    if (userName != null)
      params = params.append('phoneNumber', userName);

    if (fillter != null) {
      if (fillter.search != null)
        params = params.append('search', fillter.search);

      if (fillter.expireTimeFrom != null)
        params = params.append('expireTimeFrom', new Date(fillter.expireTimeFrom).toDateString());

      if (fillter.expireTimeTo != null)
        params = params.append('expireTimeTo', new Date(fillter.expireTimeTo).toDateString());

    }

    return this.http.get<DeviceModel[]>(
      `${this.commonService.getApiEndpoint()}/${DEVICE_HARDWARE_LIST_URL}`, { params: params }
    ).pipe(map(res => res['result'] as DeviceModel[]));
  }
  getTicketMessages(ticketId: number): Observable<TicketMessageModel[]> {
    return this.http.get<TicketMessageModel[]>(
      `${this.commonService.getApiEndpoint()}/${GET_TICKET_MESSAGE}/${ticketId}`
    ).pipe(map(res => res['result'] as TicketMessageModel[]));
  }
  getTicket(ticketId: number) {
    return this.http.get<TicketModel>(
      `${this.commonService.getApiEndpoint()}/${GET_TICKET}/${ticketId}`
    ).pipe(map(res => res['result'] as TicketModel));
  }
  GenerateInvitationLinkForUser() {
    return this.http.post(
      `${this.commonService.getApiEndpoint()}/${GET_INVITE_URL}`, null)
      .pipe(map(res => res['result'] as string));
  }

  getPurchasesReport(queryParams: PurchaseReportFillterModel) {

    let params = new HttpParams();
    if (queryParams != null) {
      params = params.append('length', queryParams.length.toString());
      params = params.append('start', queryParams.start.toString());
      params = params.append('order', queryParams.order.toString());


      if (queryParams.productId != null)
        params = params.append('productId', queryParams.productId.toString());

      if (queryParams.isBulk != null)
        params = params.append('isBulk', queryParams.isBulk.toString());

      if (queryParams.isUsed != null)
        params = params.append('isUsed', queryParams.isUsed.toString());

      if (queryParams.fromDate != null)
        params = params.append('fromDate', new Date(queryParams.fromDate).toDateString());

      if (queryParams.toDate != null)
        params = params.append('toDate', new Date(queryParams.toDate).toDateString());

      if (queryParams.bankTransaction != null)
        params = params.append('bankTransaction', queryParams.bankTransaction);

    }
    return this.http.get<PurchaseReportModel[]>(
      `${this.commonService.getApiEndpoint()}/${PURCHASE_REPORT}`, { params: params }
    ).pipe(map(res => res['result'] as any));
  }
  getUserProfile(): Observable<UserProfileModel> {
    return this.http.get<UserProfileModel>(
      `${this.commonService.getApiEndpoint()}/${GET_USER_PROFILE}`
    ).pipe(map(res => res['result'] as UserProfileModel));
  }

  getEducationLevelItems(): Observable<EnumTableModel[]> {
    return this.http.get<EnumTableModel[]>(
      `${this.commonService.getApiEndpoint()}/${GET_EDUCATION_LEVELS}`
    ).pipe(map(res => res['result'] as EnumTableModel[]));
  }

  getUsageFieldItems(): Observable<EnumTableModel[]> {
    return this.http.get<EnumTableModel[]>(
      `${this.commonService.getApiEndpoint()}/${GET_USAGE_FIELDS}`
    ).pipe(map(res => res['result'] as EnumTableModel[]));
  }

  saveUserProfile(userProfile: UserProfileModel) {
    return this.http.post(
      `${this.commonService.getApiEndpoint()}/${UPDATE_USER_PROFILE}`, userProfile)
      .pipe(map(res => res['result'] as boolean));
  }
  sendInviteLink(emails: string) {
    return this.http.get(
      `${this.commonService.getApiEndpoint()}/${SEND_INVITE_LINK}${emails}`);
  }

  sendInviteLinkBySms(phonenumber: string) {
    return this.http.get(
      `${this.commonService.getApiEndpoint()}/${SEND_INVITE_LINK_SMS}${phonenumber}`);
  }

  uploadTicketFile(data: FormData) {
    return this.http.post<string>(
      `${this.commonService.getApiEndpoint()}/${UPLOAD_TICKET_FILE}`, data, {
      reportProgress: true,
    })
      .pipe(map(res => res['result'] as string));
  }

  addTicket(data: FormData) {
    return this.http.post(
      `${this.commonService.getApiEndpoint()}/${ADD_NEW_TICKET}`, data);
  }
  addTicketMessage(data: FormData) {
    return this.http.post(
      `${this.commonService.getApiEndpoint()}/${ADD_TICKET_MESSAGE}`, data)
      .pipe(map(res => res['result'] as number));
  }
  closeTicket(ticketId: number) {
    return this.http.post(
      `${this.commonService.getApiEndpoint()}/${TICKET_CLOSE}${ticketId}`, null);
  }
  sendRequestSerialEmail(orderId: string) {
    return this.http.get(
      `${this.commonService.getApiEndpoint()}/${REQUEST_SERIAL_EMAIL}${orderId}`);
  }

  downloadSerial(orderId: string) {
    return this.http.get(
      `${this.commonService.getApiEndpoint()}/${DOWNLAOD_SERIAL}${orderId}`)
      .pipe(map(res => res['result'] as DownloadSerialModel));
    ;
  }

  getDeviceProducts(deviceId: number, phoneNumber: string = null) {
    let params = new HttpParams();
    if (phoneNumber != null)
      params = params.append('phoneNumber', phoneNumber);
    return this.http.get(
      `${this.commonService.getApiEndpoint()}/${GET_DEVICE_PRODUCTS}/${deviceId}`, { params: params })
      .pipe(map(res => res['result'] as ProductModel[]));
  }
  getUserInfo() {
    return this.http.get(
      `${this.commonService.getApiEndpoint()}/${GET_USER_INFO}`)
      .pipe(map(res => res['result'] as UserInfoModel));
  }
  reportTheftDevice(model: ReportTheftDeviceModel) {
    return this.http.post(
      `${this.commonService.getApiEndpoint()}/${REPORT_THEFT_DEVICE}`, model);
  }
  confirmTheftDevice(model: ConfirmTheftDeviceModel) {
    return this.http.post(
      `${this.commonService.getApiEndpoint()}/${CONFIRM_THEFT_DEVICE}`, model);
  }
  reportUnTheftDevice(deviceId: number) {
    return this.http.post(
      `${this.commonService.getApiEndpoint()}/${REPORT_UN_THEFT_DEVICE}/${deviceId}`, null);
  }
  getDevice(deviceId: number) {
    return this.http.get(
      `${this.commonService.getApiEndpoint()}/${GET_DEVICE}/${deviceId}`)
      .pipe(map(res => res['result'] as DeviceModel));
  }
  getAllLastIps(queryParams: DeviceIpFillterModel): Observable<TheftDetailModel[]> {
    let params = new HttpParams();
    if (queryParams != null) {
      params = params.append('length', queryParams.length.toString());
      params = params.append('start', queryParams.start.toString());
      if (queryParams.deviceId != null)
        params = params.append('deviceId', queryParams.deviceId.toString());
    }
    return this.http.get<TheftDetailModel[]>(
      `${this.commonService.getApiEndpoint()}/${GET_ALL_LAST_IPS}`, { params: params });
  }
  getDeviceLocationsByDeviceId(deviceId: number): Observable<DeviceLocationModel[]> {
    return this.http.get<DeviceLocationModel[]>(
      `${this.commonService.getApiEndpoint()}/${GET_DEVICE_LOCATIONS}/${deviceId}`)
      .pipe(map(res => res['result'] as DeviceLocationModel[]));
  }

  getLastLocation(model: DeviceGetLastLocationModel): Observable<DeviceLocationModel> {
    return this.http.post<DeviceLocationModel>(
      `${this.commonService.getApiEndpoint()}/${GET_LAST_LOCATION}`, model)
      .pipe(map(res => res['result'] as DeviceLocationModel));
  }


  changePassword(model: ChangePasswordModel) {
    return this.http.post(
      `${this.commonService.getApiEndpoint()}/${CHANGE_PASSWORD}`, model);
  }

  setPassword(model: SetPasswordModel): Observable<ApiResponseModel<boolean>> {
    return this.http.post<ApiResponseModel<boolean>>(
      `${this.commonService.getApiEndpoint()}/${SET_PASSWORD}`, model)
      .pipe(map(res => res['result'] as ApiResponseModel<boolean>));
  }

  getResellerProfile(): Observable<ResellerInfoModel> {
    return this.http.get<ResellerInfoModel>(
      `${this.commonService.getApiEndpoint()}/${GET_RESELLER_PROFILE}`)
      .pipe(map(res => res['result'] as ResellerInfoModel));
  }
  getUserDetail(userName: string) {
    return this.http.get<UserProfileModel>(
      `${this.commonService.getApiEndpoint()}/${GET_USER_DETAIL}/${userName}`)
      .pipe(map(res => res['result'] as UserProfileModel));
  }
  updateResellerInfo(model: ResellerUpdateModel) {
    return this.http.post(
      `${this.commonService.getApiEndpoint()}/${UPDATE_RESELLER_INFO}`, model)
      .pipe(map(res => res['result'] as any));
  }



  getResellerSerialPackages(model: SerialFillterModel): Observable<SerialInfoModel[]> {

    return this.http.post<SerialInfoModel[]>(
      `${this.commonService.getApiEndpoint()}/${GET_RESELLER_SERIAL_PACKAGES}`, model
    );
  }
  saveResellerDocument(data: FormData): Observable<string> {

    return this.http.post<string>(
      `${this.commonService.getApiEndpoint()}/${SAVE_RESELLER_DOCUMENT}`, data
    );
  }

  //Change user state from 0 to 4 
  requestResseller() {
    return this.http.get(
      `${this.commonService.getApiEndpoint()}/${REQUEST_RESELLER}`);
  }

  resendConfirmEmail() {
    return this.http.get(
      `${this.commonService.getApiEndpoint()}/${RESEND_CONFIRM_EMAIL}`);
  }
  confirmEmail(ucode: string, code: string) {
    return this.http.get(
      `${this.commonService.getApiEndpoint()}/${CONFIRM_EMAIL}?ucode=${ucode}&code=${code}`);
  }

  isValidEmail(email: string) {
    return this.http.get(
      `${this.commonService.getApiEndpoint()}/${ISVALID_EMAIL}${email}`)
      .pipe(map(res => res['result'] as boolean));
  }



  GetResellerMembersSerialNumber(model: ResellerMembersSerialNumberSearchModel) {
    return this.http.post<ResellerMembersProductReturnModel[]>(
      `${this.commonService.getApiEndpoint()}/${GET_RESELLER_MEMBERS_SERIAL_NUMBER}`, model
    ).pipe(map(res => res['result'] as ResellerMembersProductReturnModel[]));
    ;
  }

  CreateOptionalDiscount(code: string, captchaResponse: string) {
    let params = new HttpParams();
    params = params.append('captchaResponse', captchaResponse);

    return this.http.get(
      `${this.commonService.getApiEndpoint()}/${CREATE_OPTIONAL_DISCOUNT}${code}`, { params: params });
  }

 

  getOfferBannerImage() {
    return this.http.get(
      `${this.commonService.getApiEndpoint()}/${GET_OFFER}`)
      .pipe(map(res => res['result'] as UserOfferWebModel));
  }




  getUserBankAccountInfo() {
    return this.http.get<BankAccountInfo>(
      `${this.commonService.getApiEndpoint()}/${GET_USER_BANK_ACCOUNT_INFO}`)
      .pipe(map(res => res['result'] as BankAccountInfo));
  }

  updateUserBankAccountInfo(model: BankAccountInfo) {
    return this.http.post<boolean>(
      `${this.commonService.getApiEndpoint()}/${UPDATE_USER_BANK_ACCOUNT_INFO}`, model)
      .pipe(map(res => res['result'] as boolean));
  }

  getSheedStoreProductForWebClient(): Observable<SheedProductModel[]> {
    return this.http.get<DeviceModel[]>(
      `${this.commonService.getApiEndpoint()}/${GET_ALL_PRODUCTS}`
    ).pipe(map(res => res['result'] as SheedProductModel[]));
  }

    registerUser(model: RegisterUserModel) {
      return this.http.post<any>(
        `${this.commonService.getApiEndpoint()}/${ADD_RESELLER_USER}`, model);
    }
    
}
